import planBase from "./planBase.js";
import imageFormat from "../../definition/imageFormat.js";
import filterBase from "./filter/filterBase.js";
import previewList from "../../definition/previewList.js";

export default class CameraPlan extends planBase {
    objectType = "CameraPlanItem";
    styleColor = '#553c9a'; // Bleu foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Camera Plan";
    }


    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Preview", text: "Aperçu", type: "selectInput", dataType: "string", options: previewList, optionsType: "idSoft" },
            { name: "Format", type: "selectInput", dataType: "number", options: imageFormat, optionsType: "idSoft" },
            { text: "Délai avant déclenchement", name: "TriggerDelay", type: "numberInput", dataType: "number", tooltip: "Délai en secondes après avoir appuyer sur le bouton de prise photo avant le déclenchement de la caméra" },
            { text: "Ordre de déclenchement", name: "TriggerOrder", type: "numberInput", dataType: "number", 
                tooltip: "Indique qu'elle photo sera utilisée pour ce plan, ne s'applique que si vous avez plusieurs 'plans' de caméra. Si vous indiquer le même ordre pour plusieurs plans, la photo sera afficher en même temps pour tous les plans." },
            { text: "Caméra", name: "CameraId", type: "numberInput", dataType: "number", tooltip: "ID de la caméra à utiliser pour la prise photo, si vous n'avez que une seule caméra, laissez 0" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput"),
            { name: "Filters", text: "Filtres", type: "arrayInput", dataType: "object", options: filterBase, elementOption: "compositionElement", label: "Ajouter un filtre à ", elements: { name: "Filters", type: "objectInput", dataType: "object", options: filterBase } },
        ];
    }

    async getStyleAsync(currentElementIndex = null, force = false) {
        let style = {
            ...super.getStyle(currentElementIndex),
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'absolute',
        }
        style.backgroundImage = `url(${await this.getFilteredPathAsync(this.PreviewValue, force)})`;
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style);
        }
        else {
            style.backgroundSize = 'cover';
        }
        return style;
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            format: this.FormatName,
            cameraId: this.CameraId,
            triggerOrder: this.TriggerOrder,
            triggerDelay: this.TriggerDelay,
            filters: this.Filters.map(filter => filter.toExportObject(variableArray, ressourceArray)),
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            format: this.FormatName,
            cameraId: this.CameraId,
            triggerOrder: this.TriggerOrder,
            triggerDelay: this.TriggerDelay,
            filters: this.Filters.map(filter => filter.toObject(minify)),
            preview: this.PreviewName,
        };
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Filters", construct: Number, jsType: "Number" },
            { property: "CameraId", construct: Number, jsType: "Number" },
            { property: "TriggerOrder", construct: Number, jsType: "Number" },
            { property: "TriggerDelay", construct: Number, jsType: "Number" },
            { property: "Format", construct: Number, jsType: "Number" },
        ];
    }
}
